import React, { useState } from "react";
import Hint from "../pages/Hint";

// Change only these numbers.
// `base` = desktop / PC position for both success/fail Hood, bubble and tail.
// `failOnly` = extra desktop / PC shift only for fail Hood.
// `mobile` = separate mobile position under 640px.
// Your current Hood numbers stay untouched.
const SUCCESS_FAIL_POPUP_POSITION = {
  base: {
    sceneMinHeightPx: 430, // more space for Hood + bubble
    sceneTopPaddingPx: 42, // pushes the whole popup scene down
    hoodWidthPx: 320, // Hood size
    hoodOffsetLeftPx: -110, // move Hood left/right
    hoodOffsetBottomPx: -130, // move Hood up/down
    bubbleBottomOffsetPx: 190, // move bubble up/down on desktop / PC
    bubbleHorizontalShiftPercent: -100, // move bubble left/right on desktop / PC
    bubbleMaxWidthPx: 360, // bubble width on desktop / PC
    speechTailImageLeftPx: 300, // tail image left/right under bubble on desktop / PC
    speechTailImageBottomPx: -54, // tail image up/down under bubble on desktop / PC
    speechTailImageWidthPx: 96, // tail image width on desktop / PC
    speechTailImageHeightPx: 82, // tail image height on desktop / PC
  },
  failOnly: {
    hoodOffsetLeftPx: 0, // extra left/right only for fail Hood
    hoodOffsetBottomPx: 0, // extra up/down only for fail Hood
  },
  mobile: {
    // These values are only for mobile under 640px.
    sceneMinHeightPx: 100, // scene height on mobile
    hoodWidthPx: 248, // Hood size on mobile
    hoodOffsetLeftPx: -52, // move Hood left/right on mobile
    hoodOffsetBottomPx: -316, // move Hood up/down on mobile
    failHoodOffsetLeftPx: 0, // extra left/right only for fail Hood on mobile
    failHoodOffsetBottomPx: 0, // extra up/down only for fail Hood on mobile
    bubbleBottomOffsetPx: -118, // move bubble up/down on mobile
    bubbleHorizontalShiftPercent: -40, // move bubble left/right on mobile
    bubbleMaxWidthPx: 296, // bubble width on mobile
    speechTailImageLeftPx: 58, // tail image left/right under bubble on mobile
    speechTailImageBottomPx: -44, // tail image up/down under bubble on mobile
    speechTailImageWidthPx: 72, // tail image width on mobile
    speechTailImageHeightPx: 60, // tail image height on mobile
  },
};

function formatRatingValue(value, fallback = "No change") {
  if (value === 0) {
    return "0";
  }

  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  return String(value);
}

export default function CustomAlert({
  onClose,
  onRetry,
  onNext,
  user,
  addedOrRestRating,
  puzzleSuccessMessage,
  success,
  fen,
  after_pgn,
  config,
  trainedCategoryKey,
  trainedCategoryLabel,
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const userRating = formatRatingValue(user?.rating, "No rating available");
  const normalizeCategoryKey = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "");
  const isSuccess = success === "true" || success === true;
  const isHint = success === "hint";
  const normalizedCategoryKey = normalizeCategoryKey(trainedCategoryKey);
  const categoryRatings =
    user && user.category_rating ? user.category_rating : {};
  const matchedCategoryEntry = Object.entries(categoryRatings).find(
    ([key]) => normalizeCategoryKey(key) === normalizedCategoryKey,
  );
  const trainedCategoryRating = formatRatingValue(
    matchedCategoryEntry ? matchedCategoryEntry[1] : "",
    "--",
  );
  const categoryName = trainedCategoryLabel || "Training category";
  const ratingChangeLabel = formatRatingValue(addedOrRestRating);
  const hoodImage = imageFailed
    ? "/hood.png"
    : isSuccess
      ? "/gamefication/Hoodsuccess.png"
      : "/gamefication/Hoodfail.png";
  const heading = isSuccess ? "Correct move! Well done!" : "Wrong answer!";
  const showRetryAction = !isSuccess && typeof onRetry === "function";
  const showNextAction = typeof onNext === "function";

  if (isHint) {
    return (
      <div className="ch-custom-alert ch-custom-alert-hint">
        <style>{`
          .ch-custom-alert {
            position: relative;
            border-radius: 24px;
            padding: 18px;
            background: linear-gradient(180deg, rgba(10, 14, 19, 0.96), rgba(7, 10, 13, 0.98));
            color: #f7f0da;
            box-shadow: 0 22px 44px rgba(0, 0, 0, 0.34);
          }

          .ch-custom-alert-close {
            position: absolute;
            top: 12px;
            right: 1px;
            width: 34px;
            height: 34px;
            border: 0;
            border-radius: 999px;
            background: rgba(255,255,255,0.12);
            color: #fff7e1;
            font-size: 1rem;
            font-weight: 900;
            cursor: pointer;
          }

          .ch-custom-alert-hint-wrap {
            padding-top: 18px;
          }
        `}</style>
        <button
          type="button"
          className="ch-custom-alert-close"
          onClick={onClose}
          aria-label="Close message"
        >
          x
        </button>
        <div className="ch-custom-alert-hint-wrap">
          <Hint
            className="hint hintboard"
            showHint="showHint"
            after_pgn={after_pgn}
            fen={fen}
            config={config}
            orientation="black"
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`ch-custom-alert ${isSuccess ? "ch-custom-alert-success" : "ch-custom-alert-fail"}`}
    >
      <style>{`
        .ch-custom-alert {
          position: relative;
          border-radius: 28px;
          padding: 8px 8px 0;
          background: transparent;
          color: #f7f0da;
          box-shadow: none;
          overflow: visible;
        }

        .ch-custom-alert-stage {
          display: grid;
          grid-template-columns: minmax(0, 1fr);
          gap: 14px;
          padding-top: 18px;
          overflow: visible;
        }

        .ch-custom-alert-comic {
          position: relative;
          min-height: ${SUCCESS_FAIL_POPUP_POSITION.base.sceneMinHeightPx}px;
          display: flex;
          align-items: end;
          justify-content: center;
          padding: ${SUCCESS_FAIL_POPUP_POSITION.base.sceneTopPaddingPx}px 0 6px;
          overflow: visible;
          animation: ch-hood-enter 320ms ease-out;
        }

        .ch-custom-alert-hood {
          position: relative;
          z-index: 1;
          width: min(100%, ${SUCCESS_FAIL_POPUP_POSITION.base.hoodWidthPx}px);
          display: block;
          filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.26));
          transform-origin: center bottom;
          pointer-events: none;
          left: ${SUCCESS_FAIL_POPUP_POSITION.base.hoodOffsetLeftPx}px;
          bottom: ${SUCCESS_FAIL_POPUP_POSITION.base.hoodOffsetBottomPx}px;
        }

        .ch-custom-alert-success .ch-custom-alert-hood {
          filter:
            drop-shadow(0 0 18px rgba(98, 255, 150, 0.4))
            drop-shadow(0 18px 24px rgba(0, 0, 0, 0.26));
          animation: ch-hood-success-pop 760ms cubic-bezier(0.2, 0.9, 0.2, 1);
        }

        .ch-custom-alert-fail .ch-custom-alert-hood {
          filter:
            drop-shadow(0 0 14px rgba(255, 92, 92, 0.24))
            drop-shadow(0 18px 24px rgba(0, 0, 0, 0.26));
          animation: ch-hood-fail-wobble 720ms cubic-bezier(0.22, 0.61, 0.36, 1);
          left: ${SUCCESS_FAIL_POPUP_POSITION.base.hoodOffsetLeftPx + SUCCESS_FAIL_POPUP_POSITION.failOnly.hoodOffsetLeftPx}px;
          bottom: ${SUCCESS_FAIL_POPUP_POSITION.base.hoodOffsetBottomPx + SUCCESS_FAIL_POPUP_POSITION.failOnly.hoodOffsetBottomPx}px;
        }

        .ch-custom-alert-bubble {
          position: absolute;
          left: 50%;
          bottom: ${SUCCESS_FAIL_POPUP_POSITION.base.bubbleBottomOffsetPx}px;
          transform: translateX(${SUCCESS_FAIL_POPUP_POSITION.base.bubbleHorizontalShiftPercent}%);
          z-index: 3;
          pointer-events: auto;
          width: min(92%, ${SUCCESS_FAIL_POPUP_POSITION.base.bubbleMaxWidthPx}px);
          padding: 18px 18px 16px;
          border-radius: 26px;
          background: rgba(255, 252, 244, 0.98);
          color: #1e2b35;
          text-align: center;
          box-shadow: 0 16px 34px rgba(0, 0, 0, 0.18);
          border: 2px solid rgba(17, 28, 38, 0.14);
        }

        .ch-custom-alert-summary {
          display: grid;
          gap: 8px;
          margin-top: 12px;
          text-align: left;
        }

        .ch-custom-alert-summary-line {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 12px;
          font-size: 0.9rem;
        }

        .ch-custom-alert-summary-label {
          color: #6b5844;
          font-weight: 900;
        }

        .ch-custom-alert-summary-value {
          color: #1e2b35;
          font-weight: 900;
          text-align: right;
        }

        .ch-custom-alert-bubble-tail-image {
          position: absolute;
          left: calc(
            50% + ${SUCCESS_FAIL_POPUP_POSITION.base.bubbleHorizontalShiftPercent}% + ${SUCCESS_FAIL_POPUP_POSITION.base.speechTailImageLeftPx}px
          );
          bottom: calc(
            ${SUCCESS_FAIL_POPUP_POSITION.base.bubbleBottomOffsetPx}px + ${SUCCESS_FAIL_POPUP_POSITION.base.speechTailImageBottomPx}px
          );
          width: ${SUCCESS_FAIL_POPUP_POSITION.base.speechTailImageWidthPx}px;
          height: ${SUCCESS_FAIL_POPUP_POSITION.base.speechTailImageHeightPx}px;
          display: block;
          pointer-events: none;
          z-index: 2;
          filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.08));
        }

        @keyframes ch-hood-enter {
          from {
            opacity: 0;
            transform: translate(-140px, 46px) scale(0.82);
          }
          to {
            opacity: 1;
            transform: translate(0, 0) scale(1);
          }
        }

        @keyframes ch-hood-success-pop {
          0% {
            opacity: 0;
            transform: translateY(34px) scale(0.72) rotate(-8deg);
          }
          45% {
            opacity: 1;
            transform: translateY(-18px) scale(1.08) rotate(4deg);
          }
          72% {
            transform: translateY(4px) scale(0.98) rotate(-2deg);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1) rotate(0deg);
          }
        }

        @keyframes ch-hood-fail-wobble {
          0% {
            opacity: 0;
            transform: translateY(24px) scale(0.84) rotate(0deg);
          }
          20% {
            opacity: 1;
            transform: translateY(0) scale(1) rotate(-10deg);
          }
          38% {
            transform: translateY(0) scale(1) rotate(9deg);
          }
          56% {
            transform: translateY(0) scale(1) rotate(-7deg);
          }
          74% {
            transform: translateY(0) scale(1) rotate(4deg);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1) rotate(0deg);
          }
        }

        .ch-custom-alert-heading {
          margin: 0 0 8px;
          font-size: 1.1rem;
          font-weight: 900;
        }

        .ch-custom-alert-message {
          margin: 0;
          line-height: 1.6;
          font-weight: 700;
        }

        .ch-custom-alert-actions {
          display: flex;
          justify-content: center;
          gap: 10px;
          flex-wrap: wrap;
          margin-top: 12px;
        }

        .ch-custom-alert-action {
          min-height: 44px;
          padding: 10px 16px;
          border: 0;
          border-radius: 14px;
          font-weight: 900;
          cursor: pointer;
        }

        .ch-custom-alert-action-retry {
          background: linear-gradient(180deg, #f0d45d, #dea522);
          color: #241600;
          box-shadow: 0 12px 20px rgba(240, 212, 93, 0.18);
        }

        .ch-custom-alert-action-next {
          background: linear-gradient(180deg, #1bb16a, #0b6f42);
          color: #eefef5;
          box-shadow: 0 12px 20px rgba(27, 177, 106, 0.2);
        }

        .ch-custom-alert-success .ch-custom-alert-heading {
          color: #256f37;
        }

        .ch-custom-alert-fail .ch-custom-alert-heading {
          color: #7b2d2d;
        }

        @media (max-width: 640px) {
          .ch-custom-alert {
            padding: 6px 6px 0;
            border-radius: 22px;
          }

          .ch-custom-alert-comic {
            min-height: ${SUCCESS_FAIL_POPUP_POSITION.mobile.sceneMinHeightPx}px;
          }

          .ch-custom-alert-bubble {
            bottom: ${SUCCESS_FAIL_POPUP_POSITION.mobile.bubbleBottomOffsetPx}px;
            transform: translateX(${SUCCESS_FAIL_POPUP_POSITION.mobile.bubbleHorizontalShiftPercent}%);
            width: min(96%, ${SUCCESS_FAIL_POPUP_POSITION.mobile.bubbleMaxWidthPx}px);
            padding: 16px 14px;
            border-radius: 20px;
          }

          .ch-custom-alert-bubble-tail-image {
            left: calc(
              50% + ${SUCCESS_FAIL_POPUP_POSITION.mobile.bubbleHorizontalShiftPercent}% + ${SUCCESS_FAIL_POPUP_POSITION.mobile.speechTailImageLeftPx}px
            );
            bottom: calc(
              ${SUCCESS_FAIL_POPUP_POSITION.mobile.bubbleBottomOffsetPx}px + ${SUCCESS_FAIL_POPUP_POSITION.mobile.speechTailImageBottomPx}px
            );
            width: ${SUCCESS_FAIL_POPUP_POSITION.mobile.speechTailImageWidthPx}px;
            height: ${SUCCESS_FAIL_POPUP_POSITION.mobile.speechTailImageHeightPx}px;
          }

          .ch-custom-alert-hood {
            width: min(100%, ${SUCCESS_FAIL_POPUP_POSITION.mobile.hoodWidthPx}px);
            left: ${SUCCESS_FAIL_POPUP_POSITION.mobile.hoodOffsetLeftPx}px;
            bottom: ${SUCCESS_FAIL_POPUP_POSITION.mobile.hoodOffsetBottomPx}px;
          }

          .ch-custom-alert-fail .ch-custom-alert-hood {
            left: ${SUCCESS_FAIL_POPUP_POSITION.mobile.hoodOffsetLeftPx + SUCCESS_FAIL_POPUP_POSITION.mobile.failHoodOffsetLeftPx}px;
            bottom: ${SUCCESS_FAIL_POPUP_POSITION.mobile.hoodOffsetBottomPx + SUCCESS_FAIL_POPUP_POSITION.mobile.failHoodOffsetBottomPx}px;
          }

          .ch-custom-alert-summary-line {
            font-size: 0.82rem;
          }
        }
      `}</style>

      <div className="ch-custom-alert-stage">
        <div className="ch-custom-alert-comic">
          <img
            src="/gamefication/ogon.png"
            alt=""
            className="ch-custom-alert-bubble-tail-image"
            aria-hidden="true"
          />
          <div className="ch-custom-alert-bubble">
            <h4 className="ch-custom-alert-heading">{heading}</h4>
            <p className="ch-custom-alert-message">{puzzleSuccessMessage}</p>
            <div className="ch-custom-alert-summary">
              <div className="ch-custom-alert-summary-line">
                <span className="ch-custom-alert-summary-label">Category</span>
                <span className="ch-custom-alert-summary-value">
                  {categoryName}
                </span>
              </div>
              <div className="ch-custom-alert-summary-line">
                <span className="ch-custom-alert-summary-label">
                  Category rating
                </span>
                <span className="ch-custom-alert-summary-value">
                  {trainedCategoryRating}
                </span>
              </div>
              <div className="ch-custom-alert-summary-line">
                <span className="ch-custom-alert-summary-label">
                  Your new rating
                </span>
                <span className="ch-custom-alert-summary-value">
                  {userRating}
                </span>
              </div>
              <div className="ch-custom-alert-summary-line">
                <span className="ch-custom-alert-summary-label">
                  Rating change
                </span>
                <span className="ch-custom-alert-summary-value">
                  {ratingChangeLabel}
                </span>
              </div>
            </div>
            {(showRetryAction || showNextAction) && (
              <div className="ch-custom-alert-actions">
                {showRetryAction && (
                  <button
                    type="button"
                    className="ch-custom-alert-action ch-custom-alert-action-retry"
                    onClick={onRetry}
                  >
                    Try again
                  </button>
                )}
                {showNextAction && (
                  <button
                    type="button"
                    className="ch-custom-alert-action ch-custom-alert-action-next"
                    onClick={onNext}
                  >
                    Next
                  </button>
                )}
              </div>
            )}
          </div>
          <img
            src={hoodImage}
            alt={isSuccess ? "Hood success" : "Hood fail"}
            className="ch-custom-alert-hood"
            onError={() => setImageFailed(true)}
          />
        </div>
      </div>
    </div>
  );
}
